import React, { useState } from 'react';
import styled from 'styled-components';
import { Grid, GridItem } from '@bwoty-web/ui-kit';
import { Button, HotelHitLoader } from '@bwoty-web/styleguide';

import MapContainer from './map/MapContainer';
import HotelContainer from './HotelContainer';
import PriceDetailsPopup from './details/PriceDetailsPopup';
import { useInitialState } from '../hooks/useInitialState';
import { useHotelsContext } from '../context/Hotels';
import { useLocationContext } from '../context/Location';

const HotelLoaders = styled.div`
  margin-top: 20px;
`;

const ListFooter = styled.div`
  margin-top: 28px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// shouldClientFetchHotels was removed, should probably be put back and implemented for SSR SEO reasons.

const HotelListContainer = () => {
  const [priceDetailsHotel, setPriceDetailsHotel] = useState(null);
  const location = useLocationContext();
  const hotelsResult = useHotelsContext();

  const {
    hotels,
    hotelIds,
    hasHotels,
    hasAll,
    isLoadingInitialHotels,
    isLoadingMoreHotels,
    isLoadingRefetchHotels,
    fetchAllHotels,
    fetchMoreHotels,
  } = hotelsResult;

  const {
    umbracoTexts: { labels: texts },
  } = useInitialState();

  const isMapView = location.searchParams.view === 'map';

  const shouldRenderLoading =
    !isMapView && (isLoadingMoreHotels || isLoadingInitialHotels || isLoadingRefetchHotels);

  return (
    <>
      <MapContainer
        hotels={hotels}
        hotelIds={hotelIds}
        hasAll={hasAll}
        fetchAllHotels={fetchAllHotels}
        isLoadingHotels={isLoadingInitialHotels}
      />
      {!isMapView && !isLoadingInitialHotels && !isLoadingRefetchHotels && hasHotels && (
        <Grid>
          {hotelIds.map((id, i) => (
            <GridItem key={`${id}_${i}`} columnSpan={12}>
              <HotelContainer
                hotelObject={hotels[id]}
                location={location}
                openPriceDetails={setPriceDetailsHotel}
                position={i + 1}
              />
            </GridItem>
          ))}
        </Grid>
      )}
      {shouldRenderLoading && (
        <HotelLoaders>
          <HotelHitLoader />
        </HotelLoaders>
      )}
      {!hasAll && !isMapView && !isLoadingMoreHotels && !isLoadingInitialHotels && (
        <ListFooter>
          <Button
            theme="primary"
            loading={isLoadingMoreHotels}
            onClick={fetchMoreHotels}
            data-test="hf-showmore"
          >
            {texts?.loadMore}
          </Button>
        </ListFooter>
      )}
      <PriceDetailsPopup
        hotelObject={priceDetailsHotel}
        clearHotel={() => setPriceDetailsHotel(null)}
      />
    </>
  );
};

export default HotelListContainer;
